export const tableEditors = {}
